import { Server, Response } from 'miragejs'
import { checkInResponse } from '@/mock/reponses/checkin_200'
import { onboardingSlides } from '@/mock/reponses/onboarding_slides_200'
import { dashboardContent } from '@/mock/reponses/dashboard_content_200'
import  meResponse from '@/mock/reponses/me_200.json'
import  reservations from '@/mock/reponses/reservations_200.json'

const defaultHeaders = {
  'content-type': 'application/json'
}
const apiUrl = process.env.VUE_APP_API_URL

let apiState = {
  loggedIn: !!window.sessionStorage.getItem('API_FAKE__IS_LOGGED_ID'),
  token: '78437_fake_token_78478'
}

export function makeServer () {
  return new Server({

    routes () {
      this.urlPrefix = apiUrl
      this.get('/api/csrf-cookie', () => '')

      this.get('/api/me', () => {
        if (!apiState.loggedIn) {
          return new Response(401, defaultHeaders,{'message': 'Test from mirage'})
        }
        console.log('meResponse: ', meResponse)

        return new Response(200, defaultHeaders, meResponse)
      })

      this.post('/api/me/onboarding-completed', () => {
        return new Response(200)
      })

      this.post('/api/me/generate-login', () => {
        console.info(`Please here to login: ${getBaseUrl()}/login/${apiState.token}`)
        return {'message': 'success'}
      })

      this.get('/api/me/login/:token', (schema, request) => {
        if (request.params.token === apiState.token) {
          window.sessionStorage.setItem('API_FAKE__IS_LOGGED_ID', '1')
          return {'login': 'success'}
        }
        return new Response(401, defaultHeaders,{'message': 'Test from mirage'})
      })

      this.get('/content-api/collections/check-in/entries/a989ea8c-29a6-4b57-a42e-382e557b191a', () => {
        return checkInResponse
      })

      this.get('/content-api/collections/onboarding/entries', () => {
        return onboardingSlides
      })

      this.get('/content-api/collections/dashboard/entries/0e802b1f-01d7-4306-9e8d-b2e833c57e26', () => {
        return dashboardContent
      })

      this.get('/api/me/reservations', () => {
        return new Response(200, defaultHeaders, JSON.parse(reservations))
      })

      this.passthrough()

    }
  })
}



const getBaseUrl = () => {
  const urlParsed = parseURL(window.destination.href)
  return `${urlParsed.protocol}//${urlParsed.host}`
}

const parseURL = (url) => {
  let parser = document.createElement('a'),
    searchObject = {},
    queries, split, i
  // Let the browser do the work
  parser.href = url
  // Convert query string to object
  queries = parser.search.replace(/^\?/, '').split('&')
  for (i = 0; i < queries.length; i++) {
    split = queries[i].split('=')
    searchObject[split[0]] = split[1]
  }
  return {
    protocol: parser.protocol,
    host: parser.host,
    hostname: parser.hostname,
    port: parser.port,
    pathname: parser.pathname,
    search: parser.search,
    searchObject: searchObject,
    hash: parser.hash
  }
}
